<template>
  <div>
        <div class="update_wrap">
            <span class="text_span">刷新时间: {{lodeTime}}</span>
            <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
        </div>
        <div style="height:350px;overflow-y:scroll">
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0" style="height:auto">
            <tr  class="ivu-table-cell">
                <th>测点名称</th>
                <th>当前状态</th>
            </tr>
            <tr v-for="(tab,$index) in list" :key="$index" class="textC">
                <td>
                    <span class="ivu-table-cell">{{tab.pointName}}</span>
                </td>
                <td v-if="tab.type=='20439'">
                    <span v-if="Number(tab.value)==1" style="color:red">动火</span>
                    <span v-else-if="Number(tab.value)==0">未动火</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20440'">
                    <span v-if="Number(tab.value)==1" style="color:red">人员离开</span>
                    <span v-else-if="Number(tab.value)==0">人员未离开</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20441'">
                    <span v-if="Number(tab.value)==0">设备正常</span>
                    <span v-else-if="Number(tab.value)==1" style="color:red">维保时间到达</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20442'">
                    <span v-if="Number(tab.value)==1" style="color:red">火情发生</span>
                    <span v-else-if="Number(tab.value)==0">无火情发生</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20443'">
                    <span v-if="Number(tab.value)==1" style="color:red">灭火开始</span>
                    <span v-else-if="Number(tab.value)==0">灭火结束/未执行</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20444'">
                    <span v-if="Number(tab.value)==1" style="color:red">正在巡检</span>
                    <span v-else-if="Number(tab.value)==0">结束/未巡检</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20445'">
                    <span v-if="Number(tab.value)==1" style="color:red">燃气切断</span>
                    <span v-else-if="Number(tab.value)==0">正常</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20446'">
                    <span v-if="Number(tab.value)==1" style="color:red">电源切断</span>
                    <span v-else-if="Number(tab.value)==0">正常</span>
                    <span v-else>~</span>
                </td>
                <td v-if="tab.type=='20447'">
                    <span v-if="Number(tab.value)==1" style="color:red">主电断开</span>
                    <span v-else-if="Number(tab.value)==0">主电接入</span>
                    <span v-else>~</span>
                </td>
            </tr>
        </table>
       </div>
    </div>
</template>
<script>
import lineChart from '@/components/line.vue';
import { getDate } from '@/assets/js/index.js';
export default {
  name:"",    
  data: () => ({
    lineData: {
        x: [],
        y: [],
    },
    loadValue: {},
    lodeTime: '',
    list: [],
  }),
  props: ['partId'],
  components: {
    lineChart
  },
  created() {

  },
  mounted() {
    this.getData();
  },
  computed: {

  },
  methods: {
    getData(){
        this.refresh();
        this.getTable();
    },
    refresh() {
        this.lodeTime = getDate(new Date().getTime(), 'year');
        this.getTable();
    },

    getTable() {
        this.lineData =  {
            x: [],
            y: [],
        };
        this.loadValue = {};
        this.list = [];

        return new Promise((resolve, reject) => {
            let url = `/mcbw/network_monitor/pointNowValue/${this.partId}`;
            let _this = this;
            var data = {
                type: 'get',
                url: url,
                obj: {
                    orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    type: 'zt',
                }
            };
            _this.$Axios(data).then((res) => {
                if (res) {
                    this.list = res.data.data;
                }
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/ .ivu-table th,
/deep/ .ivu-table td{
    text-align: center;
} 
.text_span{
    color: #515a6e;
}
table{
    width: 100%
}
.update_wrap{
    display: flex;
    justify-content: flex-end;
    .update_info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
            margin-right: 10px;
        }
        img{
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
    }
}
.ivu-table{
    tr{
        background-color: #515a6e
    }
}
</style>


// WEBPACK FOOTER //
// src/components/zdmh/zt.vue